import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import { app } from '../api/firebaseConfig.ts';

export interface UploadProgress {
  [key: number]: number;
}

const storage = getStorage(app);

export const useUploadImages = ({
  setUploadProgress,
  userUuid,
}: {
  setUploadProgress: (cb: (prev: UploadProgress) => UploadProgress) => void;
  userUuid: string;
}): {
  uploadImages: (files: File[], rootFolder?: string) => Promise<string[]>;
} => {
  const uploadImages = (files: File[], rootFolder: string = 'uploads') => {
    return Promise.all(
      files.map(
        (file, index) =>
          new Promise<string>((resolve, reject) => {
            const storageRef = ref(
              storage,
              `${rootFolder}/${userUuid}_${uuidv4()}_${file.name}`,
            );
            const uploadTask = uploadBytesResumable(storageRef, file);

            uploadTask.on(
              'state_changed',
              (snapshot) => {
                const progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                setUploadProgress((prev) => ({
                  ...prev,
                  [index]: progress,
                }));
              },
              (error) => {
                console.error(`Upload error ${file.name}: `, error);
                reject(error);
              },
              async () => {
                try {
                  const downloadURL = await getDownloadURL(
                    uploadTask.snapshot.ref,
                  );
                  resolve(downloadURL);
                } catch (error) {
                  console.error(`Getting url error ${file.name}: `, error);
                  reject(error);
                }
              },
            );
          }),
      ),
    );
  };

  return { uploadImages };
};
